"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var validateEmail = function validateEmail(email) {
    var re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return re.test(email);
  };
  return function (input) {
    return validateEmail(input);
  };
};

;


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/email.filter.js
// module id = 147
// module chunks = 2